import React from 'react';

import { IIconProps, TIconType } from '../interface';

const UncheckIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
		>
			<rect
				fill={props?.color}
				height='20'
				rx='4'
				width='20'
			/>
		</svg>
	);
};

export default UncheckIcon;
